<template>
    <v-form ref="form" style="width: 100%" v-model="valid">
        <div class="d-flex align-center flex-wrap mb-3">
            <div class="mr-3">
                <DateInput v-model="fields.date"/>
            </div>
            <div class="mr-3">
                <v-select
                    :items="stateList"
                    filled
                    hide-details
                    label="Estado"
                    v-model="fields.state"
                    :disabled="loading"
                    @change="changed('state', $event)"
                    />
            </div>
        </div>
        <div class="d-flex flex-wrap align-center mb-3">
            <div class="mr-3">
                <v-select
                    :items="juegoShaped"
                    item-text="name"
                    item-value="id"
                    label="Juego"
                    v-model="fields.juego_id"
                    hide-details
                    filled
                    :disabled="loading || loadingJuegoList" :loading="loadingJuegoList"
                    clearable
                    @change="changed('juego_id', $event)"
                    />
            </div>
            <div class="mr-3">
                <v-select
                    :items="juegoSorteoList"
                    item-text="horario"
                    item-value="id"
                    label="Sorteo"
                    v-model="fields.juego_sorteo_id"
                    hide-details
                    filled
                    :disabled="loading || loadingJuegoSorteoList || !fields.juego_id" :loading="loadingJuegoSorteoList"
                    @change="changed('juego_sorteo_id', $event)"
                    />
            </div>
            <div class="mr-3">
                <SelectorNumero v-model="fields.numero" :disabled="!this.fields.juego_id" :params="{juego_id: this.fields.juego_id}" filled/>
            </div>
            <div class="mr-3">
                <v-text-field
                    v-model="fields.search"
                    @change="changed('search', $event)"
                    append-icon="mdi-magnify"
                    filled
                    label="Número Control"
                    hide-details
                    clearable
                    />
            </div>
        </div>
        <div class="d-flex">
            <v-spacer/>
            <v-btn text class="mr-3" :disabled="loading" @click="reset()">Reiniciar Filtros</v-btn>
            <v-btn color="primary" :disabled="loading" :loading="loading" @click="search()"><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
        </div>
    </v-form>
    
</template>

<script>
import Search from '@mixins/search';
import JuegoService from '@services/sistema/JuegoService';
import JuegoSorteoService from '@services/sistema/JuegoSorteoService';

export default {
    props: {
        'value': {}, 
        'loading': {},
    },
    mixins: [Search],
    data: function ()  {
        return {
            stateList: [
                {
                    text: 'Todos',
                    value: null,
                },
                {
                    text: 'Anulados',
                    value: '-1',
                },
                {
                    text: 'Vendidos',
                    value: '0',
                },
                {
                    text: 'Ganadores',
                    value: '1',
                },
                {
                    text: 'Pagados',
                    value: '2',
                }
            ],

            defaultFields: {
                search: null,
                state: null,
                juego_id: null,
                juego_sorteo_id: null,
                numero: null,
                date: this.$luxon.local().toISODate(),
            },
            
            loadingJuegoList: false,
            juegoList: [],

            loadingJuegoSorteoList: false,
            juegoSorteoList: [],

        }
    },
    computed: {
        juegoShaped: function () { 
            return this.juegoList.map((juego) => ({
                name: juego.loteria ? juego.loteria.name + '/' + juego.name: juego.name,
                id: juego.id,
            }));
        },
        defaultJuegoSlug: function () {
            return this.$store.getters['persist/default/defaultJuegoSlug'];
        }
    },
    created: function () {
        this.getJuegoList();
    },
    mounted: function () {
        this.preloadLists();
    },
    methods: {
        getJuegoList: function () {
            this.juegoList = [];
            this.isLoadingJuegoList = true;
            JuegoService.getList()
                .then(({ juegoList }) => {
                    this.juegoList = juegoList;
                    if (!this.fields.juego_id) this.fields.juego_id = this.juegoList.find((juego) => juego.slug == this.defaultJuegoSlug)?.id;
                })
                .finally(() => this.isLoadingJuegoList = false);
        },
        getJuegoSorteoList: function (parent_id = null) {
            const juego_id = this.fields.juego_id || parent_id
            this.juegoSorteoList = [];
            if (!juego_id) return;
            this.isLoadingJuegoSorteoList = true;
            JuegoSorteoService.getList(juego_id)
                .then(({ juegoSorteoList }) => {
                    this.juegoSorteoList = [
                        {
                            horario: 'Todos',
                            id: null,
                        },
                        ...juegoSorteoList
                    ];
                    const hora = this.$luxon.now().minus({hours: 1});
                    if (!this.fields.juego_sorteo_id) this.fields.juego_sorteo_id = juegoSorteoList.find((juegoSorteo) => hora <= this.$luxon.fromFormat(juegoSorteo.horario, 'HH:mm:ss'))?.id;
                    if (this.fields.juego_sorteo_id) {
                        this.changed('juego_sorteo_id', this.fields.juego_sorteo_id);
                        this.search()
                    }
                })
                .finally(() => this.isLoadingJuegoSorteoList = false);
        },
        preloadLists: function () {
            const defaults = this.default;
            if (defaults.juego_id) {
                this.getJuegoSorteoList();
            }
        },
        onChange: function (field) {
            switch(field) {
                case 'juego_id':
                    this.fields.juego_sorteo_id = null;
                break;
            }
        }
    },
    watch: {
        'fields.juego_id': function (juego_id) {
            if (juego_id !== null) this.getJuegoSorteoList();
        },
    }
}
</script>

<style>

</style>